import React from 'react';
import PropTypes from 'prop-types';
import {getTranslate} from 'utils/attribute-util';
import {isValid} from 'validators/number-validator';
import styles from './index.css';

export default class ColumnStep extends React.Component {
  static propTypes = {
    height: PropTypes.number,
    style: PropTypes.object,
    width: PropTypes.number,
    x: PropTypes.number,
    y: PropTypes.number,
  };

  static defaultProps = {
    height: 3,
    style: {},
    width: 0,
    x: 0,
    y: 0,
  };

  getWidth(width) {
    return isValid(width) ? Math.ceil((width / 3) * 2) : 0;
  }

  getX(width, stepWidth) {
    if (isValid(width) && isValid(stepWidth)) {
      const x = (width - stepWidth) / 2 + 1;
      return x > 0 ? x : 0;
    }
    return 0;
  }

  getY(height) {
    if (isValid(height)) {
      return -Math.round(height / 2);
    }
    return 0;
  }

  render() {
    const translate = getTranslate(this.props.x, this.props.y);
    const width = this.getWidth(this.props.width);
    const x = this.getX(this.props.width, width);
    const y = this.getY(this.props.height);
    return (
      <g className={styles.ColumnStep} transform={translate}>
        <rect
          fill={this.props.style.fill || null}
          height={this.props.height}
          stroke={this.props.style.stroke}
          strokeWidth={this.props.style.strokeWidth}
          width={width}
          x={x}
          y={y}
        />
      </g>
    );
  }
}
